import { Nav, Tab } from "react-bootstrap";
import { INonComplianceDetails } from "../../../api/INonCompliance";
import { ILicenceProfile } from "../../../api/LicenceProfile";
import { DocumentsGrid } from "../../../leap-components/Documents/DocumentsGrid";
import EpaCard from "../../../leap-components/EpaCard";
import { SiteVisitsGrid } from "../../../leap-components/SiteVisits/SiteVisitsGrid";
import { SiteVisitRegardingObjectTypes } from "../../../leap-components/SiteVisits/SiteVisitsGridProps";

interface SubTabsProps {
  className?: string;
  activeKey: string;
  nonComplianceDetails: INonComplianceDetails;
  licenceProfile: ILicenceProfile;
}

interface RelatecComplianceProps {
  nonComplianceDetails: INonComplianceDetails;
  licenceProfile: ILicenceProfile;
}

const SubTabs = ({
  className,
  activeKey,
  nonComplianceDetails,
  licenceProfile,
}: SubTabsProps) => (
  <div className={"tab " + className}>
    <Tab.Container id="left-tabs-example" defaultActiveKey={activeKey}>
      <Nav variant="tabs">
        <Nav.Item>
          <Nav.Link eventKey="documents">Documents</Nav.Link>
        </Nav.Item>
        <Nav.Item>
          <Nav.Link eventKey="site-visits">Site Visits</Nav.Link>
        </Nav.Item>
      </Nav>
      <Tab.Content>
        <Tab.Pane eventKey="documents">
          <DocumentsGrid
            regardingObjectId={nonComplianceDetails.noncomplianceid}
          />
        </Tab.Pane>
        <Tab.Pane eventKey="site-visits">
          <SiteVisitsGrid
            regardingObjectId={nonComplianceDetails.noncomplianceid}
            regardingObjectType={SiteVisitRegardingObjectTypes.NC}
          />
        </Tab.Pane>
      </Tab.Content>
    </Tab.Container>
  </div>
);

const RelatedComplianceRecords = ({
  nonComplianceDetails,
  licenceProfile,
}: RelatecComplianceProps) => {
  var bodyElements = (
    <SubTabs
      activeKey="documents"
      nonComplianceDetails={nonComplianceDetails}
      licenceProfile={licenceProfile}
    />
  );
  return (
    <EpaCard title={"Related Compliance Records"} content={bodyElements} />
  );
};

export default RelatedComplianceRecords;
